import reducer from "./reducer";
export { default as alertsTemplates } from "./components/index";
export { default as alertsTemplatesReducerName } from "./constants";
export default reducer;
